function ProjectsPage() {
    return (
        <div className="projects-page">
            <h1>پروژه‌های ما</h1>
            <p>در اینجا می‌توانید لیستی از پروژه‌های انجام‌شده توسط شرکت ما را مشاهده کنید.</p>
        </div>
    );
}

export default ProjectsPage;
